import React from "react";
import { Alert } from "react-native";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppDispatch } from "@/hooks/application/store";
import { useCompanyTypes } from "@/hooks/domain/companyTypes";
import { useSignupCompany } from "@/hooks/domain/signup";
import { AuthNavigation } from "@/navigation/stacks/AuthenticationStack";
import analytics from "@/services/analytics";
import { logger } from "@/services/logger";
import { registerForPushNotificationsAsync } from "@/services/notification";
import { LOGIN } from "@/store/ducks/auth";
import { isNativeDevice } from "@/utils/platform";

import SignupCompanyMobile from "./SignUpCompany.mobile";
import SignupCompanyWeb from "./SignUpCompany.web";
import { CompanyFormData } from "./schema";

const SignupCompany = () => {
  const { isWebMode } = useViewport();

  const { goBack } = useAppNavigation<AuthNavigation>();

  const { data, isLoading } = useCompanyTypes();

  const dispatch = useAppDispatch();

  const { mutate, isLoading: isSubmiting } = useSignupCompany({
    onSuccess: (data) => {
      dispatch(LOGIN(data.usuario));
    },
    onError: (error) => {
      logger.error(error);
      Alert.alert("Não conseguimos criar a sua conta", "Tente novamente mais tarde");
    },
  });

  const onSubmit = async (data: CompanyFormData) => {
    let notificationToken = undefined;
    if (isNativeDevice) {
      notificationToken = await registerForPushNotificationsAsync();
    }
    analytics.logEvent("lead", {
      name: data.nome,
      phone: data.telefone,
      type: "B2B",
    });
    mutate({
      email: data.email.trim(),
      nome: data.nome,
      senha: data.senha.trim(),
      telefone: data.telefone,
      tokenExpo: notificationToken,
      cnpj: data.cnpj,
      razaoSocial: data.razaoSocial,
      tipoEmpresaId: data.tipoNegocio,
      mediaFaturamento: parseFloat(data.mediaFaturamento),
    });
  };

  const onCancel = () => goBack();

  const Screen = isWebMode ? SignupCompanyWeb : SignupCompanyMobile;

  return (
    <Screen
      companyTypes={data}
      isLoading={isLoading}
      isSubmiting={isSubmiting}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
};

export default SignupCompany;
